import { useState } from 'react';
import { Button, Grid, Menu } from '@mantine/core';

import { IconCreditCard, IconEye, IconSettingsAutomation, IconShoppingCartPlus, IconStar, IconUserPlus } from '@tabler/icons-react';

import facebookFilters from '../../constants/Rules/facebookAudienceFilters';
import availableAudienceRules from '../../constants/Rules/facebookAudienceRules';
import userListFilters from '../../constants/Rules/googleUserListFilters';
import { userListFlexibleRuleOperator } from '../../constants/Rules/googleUserListRules';

import Spinner from '../Spinner';
import AudienceRule from './AudienceRule';

const ruleIcons = {
  viewedProduct: <IconEye size={16} />,
  addedToWishlist: <IconStar size={16} />,
  addedToCart: <IconShoppingCartPlus size={16} />,
  purchased: <IconCreditCard size={16} />,
  profileSubscribed: <IconUserPlus size={16} />,
  customEvent: <IconSettingsAutomation size={16} />,
};

const CustomAudienceRules = ({ segment, updateSegment, readOnly }) => {
  const [segmentState, setSegmentState] = useState(
    segment.rules.map((r) => segment.rules.indexOf(r) === segment.rules.length - 1)
  );

  const availableRules = segment.scope === 'facebook' ? availableAudienceRules : userListFlexibleRuleOperator;
  const filters = segment.scope === 'facebook' ? facebookFilters : userListFilters;

  const addRule = (rule) => {
    const filtersArray = [
      segment.scope === 'google' ? { ...filters.match } : null,
      { ...filters.retentionDays, values: [30] },
    ].filter(Boolean);

    const ruleToAdd = {
      ...rule,
      filters: filtersArray,
    };

    const updatedSegment = { ...segment };
    updatedSegment.rules = [...segment.rules];
    updatedSegment.rules.push(ruleToAdd);
    updateSegment(updatedSegment);
    const updatedState = [...segmentState];
    updatedState.push(true);
    setSegmentState(updatedState);
  };

  const updateRule = (index, rule) => {
    const updatedSegment = { ...segment };
    updatedSegment.rules = [...segment.rules];
    updatedSegment.rules[index] = rule;
    updateSegment(updatedSegment);
  };

  const removeRule = (index) => {
    const updatedSegment = { ...segment };
    updatedSegment.rules = [...segment.rules];
    updatedSegment.rules.splice(index, 1);
    const updatedState = [...segmentState];
    updatedState.splice(index, 1);

    updateSegment(updatedSegment);
    setSegmentState(updatedState);
  };

  const toggle = (index) => {
    const updatedState = [...segmentState];
    updatedState[index] = !segmentState[index];
    setSegmentState(updatedState);
  };

  if (!segment) {
    return <Spinner />;
  }

  const segmentRules = segment.rules.map((rule, index) => {
    const divider = index > 0 ? <p>and</p> : null;

    return (
      <div key={index} data-rule-name={rule.name}>
        {divider}
        <AudienceRule
          filters={filters}
          availableRules={availableRules}
          readOnly={readOnly}
          index={index}
          updateRule={(segment) => updateRule(index, segment)}
          removeRule={() => removeRule(index)}
          rule={rule}
          toggle={() => toggle(index)}
          open={segmentState[index]}
          icon={ruleIcons[rule.key]}
        />
      </div>
    );
  });

  const dropdownItems = availableRules.map((rule, index) => (
    <Menu.Item key={index} onClick={() => addRule(rule)} rule-name={rule.name}>
      {ruleIcons[rule.key]} {rule.name}
    </Menu.Item>
  ));

  const dropdownContent = (
    <Menu data-tour="segmentAddRuleBtn">
      <Menu.Target>
        <Button variant="default" disabled={readOnly}>
          {segment.scope === 'google' ? 'Add URL Rules' : 'Add Rules'}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>{dropdownItems}</Menu.Dropdown>
    </Menu>
  );

  return (
    <>
      <Grid>
        <Grid.Col span={12}>{dropdownContent}</Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>{segmentRules}</Grid.Col>
      </Grid>
    </>
  );
};

export default CustomAudienceRules;
